export default __webpack_public_path__ + "images/57cad57dbc92f867b1141aa6178dbdaf-chicago_mobile.webp";